import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {RegistrationApiService} from "../../api/registration-api.service";
import {RegistrationDto, RegistrationRequestOtpDto} from "../../types/registration.types";
import {SignUpService} from "../../service/sign-up.service";
import {CoreApiService} from "../../../core/service/core-api.service";
import {RegistrationBaseComponent} from "../registration-base-component/registration-base-component";
import {finalize} from "rxjs";
import {Router} from "@angular/router";
import {AuthService} from "../../../core/service/auth.service";
import {ImageCroppedEvent} from "ngx-image-cropper";
import { MessageHelper } from '../../../core/helper/message-helper';
import {AppMessageService} from "../../../core/service/app-message.service";


@Component({
  selector: 'registration-account-setup',
  templateUrl: './registration-account-setup.component.html',
  styleUrls: ['./registration-account-setup.component.css']
})
export class RegistrationAccountSetupComponent extends RegistrationBaseComponent {

  imageSrc: string | undefined;
  tempImageSrc: string | undefined;
  imageChangedEvent: any = '';
  croppedImage: any = '';
  showImageCropperDialog = false;
  constructor(protected override registrationApiService: RegistrationApiService,
              protected override signUpService: SignUpService,
              protected router: Router,
              protected authService: AuthService,
              protected messageService: AppMessageService,
              protected override coreApiService: CoreApiService) {
    super(registrationApiService, signUpService, coreApiService);
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.initComponent();
  }

  /**
   * Initialize Component.
   */
  override initComponent() {

    this.refreshComponent();
  }

  /**
   * Refresh Component.
   */
  override refreshComponent() {

    if (this.formGroup && this.formGroup.get('profileImage')?.value) {
      this.imageSrc = this.formGroup.get('profileImage')?.value;
    }
    this.isFormValid();
    this.initialized = true;
  }

  handleValidEmail() {
    if (this.formGroup) {
      const email = this.formGroup.get('email')?.value;

      const dto: RegistrationRequestOtpDto = {
        phoneNumber: this.signUpService.phoneNumber as string,
        registrationGuid: this.signUpService.registrationGuid as string,
        deviceInfo: this.coreApiService.getDeviceInfo(),
        eMail: email as string,
      }

      if (email) {
        this.registrationApiService.checkEmail(dto).subscribe(res => {
          if (res.success == false) {
            this.formGroup.get('email')?.setErrors({emailTaken: res.data});
          } else {
            this.formGroup.get('email')?.setErrors(null);
          }
        }, error => {
        })
      }
    }
  }

  handlePasswordMatch() {
    const password = this.formGroup.get('password')?.value;
    const confirmPassword = this.formGroup.get('confirmPassword')?.value;

    if (!confirmPassword || password != confirmPassword) {
      this.formGroup.get('confirmPassword')?.setErrors({passwordError: 'Die Passwörter stimmen nicht überein!'});
    } else {
      this.formGroup.get('confirmPassword')?.setErrors(null);
    }
  }

  handleCheckPassword() {
    if (this.formGroup) {
      const password = this.formGroup.get('password')?.value;
      const dto: RegistrationRequestOtpDto = {
        phoneNumber: this.signUpService.phoneNumber as string,
        registrationGuid: this.signUpService.registrationGuid as string,
        deviceInfo: this.coreApiService.getDeviceInfo(),
        password: password as string,
      }
      this.handlePasswordMatch();

      if (password) {
        this.registrationApiService.checkPassword(dto).subscribe(res => {
          if (res.success == false) {
            this.formGroup.get('password')?.setErrors({invalidPassword: res.data});
          } else {
            this.formGroup.get('password')?.setErrors(null);
          }
          this.handlePasswordMatch();
        }, error => {
        })
      }
    }
  }

  isFormValid(): boolean {
    const fields = ['email', 'password', 'confirmPassword'];
    return this.isActiveFormValid(fields);
  }

  handleContinue() {
    this.updateRegistration(false);
  }

  override postObjectRefresh() {
    const password = this.formGroup.get('password');
    const confirmPassword = this.formGroup.get('confirmPassword');

    password?.setValue(null);
    password?.setErrors(null);
    confirmPassword?.setValue(null);
    confirmPassword?.setErrors(null);

    this.navigateNextStep(1);
  }

  handleDeleteImage() {
    const documentDto: Partial<RegistrationRequestOtpDto> = {
      phoneNumber: this.signUpService.phoneNumber as string,
      registrationGuid: this.signUpService.registrationGuid as string,
      deviceInfo: this.coreApiService.getDeviceInfo(),
      pictureBase64: null,
      pictureMimeType: null
    };
    this.registrationApiService.delPicture(documentDto).subscribe(res => {
      this.imageSrc = undefined;
      this.formGroup.patchValue({
        profileImage: null
      });
    }, error => {
      MessageHelper.showErrorMessage(error.error.data, this.messageService);
    })
  }

  finalizeRegistration() {

    if (this.busy) {
      return;
    }

    this.setBusy();

    const dto: RegistrationRequestOtpDto & RegistrationDto &  {[key: string]: any} = {};

    for (let key in this.formGroup.value) {
      dto[key] = this.formGroup.value[key];
    }

    // 18.03.2025 Change Birth Date to UTC
    if (dto["dateOfBirth"]) {
      // convert to UTC date
      dto["dateOfBirth"] = new Date(Date.UTC(dto["dateOfBirth"].getFullYear(), dto["dateOfBirth"].getMonth(), dto["dateOfBirth"].getDate()));
    }


    // this.formGroup.get('email')?.setErrors({emailTaken: 'hard coded error on click'});



    this.registrationApiService.finishAndLogin(dto).subscribe(res => {

      // store logon token
      this.authService.setToken(res.logonToken);

      if (res.customerCreationSuccessful) {
        //reset everything before navigation
        this.signUpService.start();
        this.router.navigate(['registration/success']);
      }

    },error => {
      let errorMessage = 'Ein unerwarteter Fehler ist aufgetreten!';
      if (error?.error?.data) {
        errorMessage = error.error.data;
      }
      this.messageService.showErrorMessage('Fehler',errorMessage);

      this.unsetBusy();
    });

  }

  setBusy() {
    this.busy = true;
    for (let controlsKey in this.formGroup.controls) {
      this.formGroup.get(controlsKey)?.disable();
    }
  }

  unsetBusy() {
    this.busy = false;
    for (let controlsKey in this.formGroup.controls) {
      this.formGroup.get(controlsKey)?.enable();
    }
  }


  onUploadHandler(event: any) {
    this.imageChangedEvent = event;
    this.showImageCropperDialog = true;
  }

  imageCropped(event: any): void {
    this.croppedImage = event.base64;

    if (!this.croppedImage && event.blob) {
      const reader = new FileReader();
      reader.onloadend = () => {
        this.croppedImage = reader.result;
      };
      reader.readAsDataURL(event.blob);
    }

    // this.imageSrc = event.objectUrl;
    this.tempImageSrc = event.objectUrl;
  }

  // Triggers the actual upload process
  uploadCroppedImage() {
    this.showImageCropperDialog = false;

    const blob = this.dataURItoBlob(this.croppedImage);
    const file = new File([blob], "cropped-image.png", { type: blob.type });

    this.convertFileToBase64AndGetType(file).then(document => {

      const documentDto: Partial<RegistrationRequestOtpDto> = {
        phoneNumber: this.signUpService.phoneNumber as string,
        registrationGuid: this.signUpService.registrationGuid as string,
        deviceInfo: this.coreApiService.getDeviceInfo(),
        pictureBase64: document.fileBase64,
        pictureMimeType: document.fileBase64MimeType
      };

      this.registrationApiService.setPictureBase64(documentDto).subscribe({
        next: (response) => {
          this.imageSrc = this.tempImageSrc;
          MessageHelper.showSuccessMessage(response.data as string, this.messageService);
        },
        error: (error) => {
          MessageHelper.showErrorMessage(error.error.data, this.messageService);
        }
      });
    });
  }

  dataURItoBlob(dataURI: string): Blob {
    const byteString = atob(dataURI.split(',')[1]);
    const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ia], { type: mimeString });
  }

  convertFileToBase64AndGetType(file: File): Promise<{ fileBase64: string; fileBase64MimeType: string; name: string }> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = function (event) {
        const result = event.target?.result;
        const base64 = typeof result === 'string' ? result.split(',')[1] : ''; // Getting the Base64 content
        resolve({
          fileBase64: base64,
          fileBase64MimeType: file.type,
          name: file.name
        });
      };
      reader.onerror = error => reject(error);
      reader.readAsDataURL(file);
    });
  }

  resetFileInput() {
    //reset file input in case a user decides not to upload an image and then choose same picture because change event doesn't trigger on same file
    const input: HTMLInputElement = document.getElementById('upload') as HTMLInputElement;
    if (input) {
      input.value = '';
    }
  }

}
